import { applyPureReactInVue } from 'veaury';

export function mountReactComponent(ReactComponent: any) {
  return applyPureReactInVue(ReactComponent);
}
